module.exports = __webpack_public_path__ + "static/media/optCrissCross.48587069.jpg";